module.exports = __webpack_public_path__ + "static/media/clock.48b28f6f.svg";